import {get, post, put, delete2, downloadFile} from "./api";
import moment from "moment";
import {TYPE_FORMAT_TIME} from "./config/constant";
import i18n from "./lang/i18n";
import routes from "./routes";
import storage from "./helper/storage";
import path from "./routes/path";
import { mapState } from "vuex";

export default {
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        ...mapState(['userPermissions']),
    },
    methods: {
        async get(url, params, loader, handleError = true) {
            let res = await get(this, url, params, loader)
            return handleError ? this.handleError(res) : res
        },
        async post(url, data, loader, handleError = true) {
            let res = await post(this, url, data, loader)
            return handleError ? this.handleError(res) : res
        },
        async put(url, data, loader, handleError = true) {
            let res = await put(this, url, data, loader)
            return handleError ? this.handleError(res) : res
        },
        async delete(url, data, loader, handleError = true) {
            let res = await delete2(this, url, data, loader)
            return handleError ? this.handleError(res) : res
        },
        async downloadFile(url, params, loader) {
            return await downloadFile(this, url, params, loader)
        },
        handleError(response) {
            if (!response.data || !response.data.status) return null;
            switch (response.data.status) {
                case 200:
                    return response.data.data;
                case 204:
                    if(response?.data?.error?.type === 'popup') {
                        this.notifDialog({
                            title: `${i18n.t("warning.warning")}!`,
                            content: response.data.error.message.replace('"', ""),
                            textConfirm: i18n.t('ui.confirm'),
                        }) 
                    } else {
                        this.showToast("warning", i18n.t("warning.warning"), i18n.t("base.noData"))
                    }
                    return response.data.data;
                case 400:
                    if(response?.data?.error?.type === 'popup') {
                        this.notifDialog({
                            title: `${i18n.t("warning.warning")}!`,
                            content: response.data.error.message.replace('"', ""),
                            textConfirm: i18n.t('ui.confirm'),
                        }) 
                    } else {
                        this.showToast("warning", i18n.t("warning.warning"), response.data.error.message)
                    }
                    return null;
                case 401:
                    this.showToast("warning", i18n.t("warning.warning"), response.data.error.message)
                    storage.clear();
                    routes.push(path.login);
                    return null
                case 403:
                    this.showToast("warning", i18n.t("warning.warning"), response.data.error.message)
                    // todo tạm thời vô hiệu đẩy ra login
                    //  storage.clear();
                    //  routes.push(path.login);
                    return null;
                default:
                    // Handle other status codes with errors
                    if (response.data.error) {
                        if (response?.data?.error?.type === 'popup') {
                            this.notifDialog({
                                title: `${i18n.t("warning.warning")}!`,
                                content: response.data.error.message.replace('"', ""),
                                textConfirm: i18n.t('ui.confirm'),
                            })
                        } else {
                            this.showToast('danger', this.$t("ui.anErrorOccurred"), response.data.error.message)
                        }
                    }
                    return null;
            }
        },
        showToast(variant, msg, sub) {
            this.$root.$emit('showToast', variant, msg, sub)
        },
        showOverlay(variant, title, subTitle, nameButton, onClick) {
            this.$root.$emit('openOverlay', variant, title, subTitle, nameButton, onClick)
        },
        confirmDialog(options) {
            this.$root.$emit('confirmDialog', options)
        },
        notifDialog(options) {
            this.$root.$emit('notifDialog', options)
        },
        formatDate(date, type) {
            return moment(date).format(type ? type : TYPE_FORMAT_TIME.HH_mm_DD_MM_YYYY);
        },
        formatNumber(number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        getKeyAvatar(name) {
            return (name && name.length > 0) ? name.substring(0, 1) : "?"
        },
        routeBack() {
            routes.go(-1);
        },
        // Permission checking methods
        hasPermission(permission) {
            // Return false if userPermissions not loaded yet to avoid errors
            if (!this.userPermissions || !Array.isArray(this.userPermissions)) {
                return false;
            }
            return this.userPermissions.includes(permission);
        },
        hasAnyPermission(permissions) {
            if (!this.userPermissions || !permissions) return false;
            return permissions.some(permission => this.userPermissions.includes(permission));
        },
        checkPermissionOrShowError(permission, errorMessage) {
            if (!this.hasPermission(permission)) {
                this.showToast('warning', this.$t('warning.warning'), errorMessage || this.$t('ui.noPermission'));
                return false;
            }
            return true;
        },
    },
};
